import React from 'react';

import { AppDispatcherContext } from 'contexts/appDispatcherContext';

export const useAppDispatcher = () => {
  return React.useContext(AppDispatcherContext);
};
